import React from 'react';
import { FiMail } from "react-icons/fi";
import { FaPhoneAlt, FaTwitter, FaLinkedin, FaWhatsapp } from "react-icons/fa";
import Button from './Button';
import { NavLink } from 'react-router-dom';

const Footer = () => {

  // Updated WhatsApp link (New Number: 9211413808)
  const whatsappLink = "https://wa.me/919211413808?text=Hello%20MD%20CONTROL%2C%20I%20visited%20your%20website.";

  // LinkedIn company profile link
  const linkedinLink = "https://www.linkedin.com/company/md-control-and-it-solutions/";

  return (
    <div className="relative mt-10 p-10 bg-gradient-to-bl from-slate-900 via-blue-800 to-blue-950 overflow-hidden">

      {/* Animated Background */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))]
        from-blue-500/10 via-blue-800/10 to-slate-900/10 blur-3xl animate-gradientMove"></div>

      {/* TOP SECTION */}
      <div className="relative z-10 grid grid-cols-1 md:grid-cols-4 gap-12 backdrop-blur-md 
      bg-white/5 rounded-3xl p-6 shadow-[0_0_25px_rgba(0,0,0,0.4)] hover:scale-[1.02] 
      transition-all duration-700 hover:shadow-[0_0_45px_rgba(30,64,175,0.6)]">

        {/* LOGO + DESCRIPTION */}
        <div className="flex flex-col items-start text-left transition-transform duration-300">
          <img 
            src='LOGO.jpg' 
            alt='Logo'
            className='w-24 sm:w-36 h-auto drop-shadow-[0_5px_15px_rgba(255,255,255,0.2)] 
            hover:scale-110 transition-transform duration-500'
          />
          <h1 className='text-white font-semibold text-lg sm:text-xl mt-4 text-left'>
            Explore the latest advancements in Industries Automation and IT Solutions.
          </h1>
        </div>

        {/* QUICK LINKS */}
        <div className='flex flex-col gap-3 text-white text-left items-start'>
          <h1 className='font-extrabold text-2xl md:text-3xl bg-gradient-to-r 
          from-blue-400 to-cyan-300 bg-clip-text text-transparent'>
            Quick Links
          </h1>

          <NavLink to="/about">
            <p className='font-semibold text-lg hover:text-blue-400 transition'>About Us</p>
          </NavLink>

          <NavLink to="/service&product">
            <p className='font-semibold text-lg hover:text-blue-400 transition'>Services & Product</p>
          </NavLink>

          <p className='font-semibold text-lg hover:text-blue-400 transition'>Pricing</p>
          <p className='font-semibold text-lg hover:text-blue-400 transition'>Team</p>
        </div>

        {/* TECHNOLOGIES */}
        <div className='flex flex-col gap-3 text-white text-left items-start'>
          <h1 className='font-extrabold text-2xl md:text-3xl bg-gradient-to-r 
          from-blue-400 to-cyan-300 bg-clip-text text-transparent'>
            Technologies
          </h1>

          <p className='font-semibold text-lg hover:text-blue-400 transition'>Scada</p>
          <p className='font-semibold text-lg hover:text-blue-400 transition'>HMI</p>
          <p className='font-semibold text-lg hover:text-blue-400 transition'>Electrial Panel</p>
          <p className='font-semibold text-lg hover:text-blue-400 transition'>Web Devlopment</p>
          <p className='font-semibold text-lg hover:text-blue-400 transition'> PLC</p>
        </div>

        {/* CONTACT INFO */}
        <div className='flex flex-col gap-6 text-white text-left items-start'>
          <h1 className='font-extrabold text-2xl md:text-3xl bg-gradient-to-r 
          from-blue-400 to-cyan-300 bg-clip-text text-transparent'>
            Contact Info
          </h1>

          <div className='flex items-center gap-4 justify-start group'>
            <FiMail className='text-3xl group-hover:scale-125 group-hover:text-cyan-300 transition-all' />
            <div>
              <p className='font-bold'>Email</p>
              <p className='text-sm'>mdcontrolanditsolutions@gmail.com</p>
            </div>
          </div>

          <div className='flex items-center gap-4 justify-start group'>
            <FaPhoneAlt className='text-3xl group-hover:scale-125 group-hover:text-cyan-300 transition-all' />
            <div>
              <p className='font-bold'>Phone</p>
              
              <p className='text-sm'>+91 8851738899</p>
              <p className='text-sm'>+91 9211413808</p> {/* NEW NUMBER ADDED */}
            </div>
          </div>
        </div>
      </div>

      {/* BOTTOM SECTION */}
      <div className='relative z-10 flex flex-col md:flex-row items-center justify-between mt-16 gap-10 text-left'>

        {/* NEWSLETTER */}
        <div className='w-full max-w-lg text-left'>
          <h1 className='text-2xl font-semibold text-white mb-4'>
            Subscribe to Our Newsletter!
          </h1>

          <form className='flex flex-col sm:flex-row gap-4 items-start'>
            <input 
              type='text'
              className='rounded-full w-full sm:w-80 p-4 bg-white/10 text-white 
              placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500'
              placeholder='Subscribe to our newsletter'
            />
            <Button text={true} firstTag={"Subscribe Now"} />
          </form>
        </div>

        {/* SOCIAL ICONS */}
        <div className='flex gap-6 justify-start w-full md:w-auto'>

          <FaTwitter className='text-4xl text-white border p-2 rounded-full hover:bg-blue-500 transition-all' />

          {/* LINKEDIN CLICKABLE */}
          <a href={linkedinLink} target="_blank" rel="noopener noreferrer">
            <FaLinkedin className='text-4xl text-white border p-2 rounded-full hover:bg-blue-700 transition-all' />
          </a>

          {/* WHATSAPP CLICKABLE */}
          <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
            <FaWhatsapp className='text-4xl text-white border p-2 rounded-full 
            hover:bg-green-500 transition-all' />
          </a>
        </div>
      </div>

      {/* DEVELOPED BY */}
      <p className="text-left md:text-center text-white mt-10 text-lg opacity-80">
        Developed by <span className="font-bold text-cyan-300">MD CONTROL</span>
      </p>

    </div>
  );
};

export default Footer;
